if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}


// Add this to your existing media-gallery.js file or create a new file

class MediaGalleryPagination {
  constructor(galleryElement) {
    this.gallery = galleryElement;
    this.slider = this.gallery.querySelector('.slider');
    this.slides = this.gallery.querySelectorAll('.slider__slide');
    this.paginationContainer = this.gallery.querySelector('.slider-pagination');
    this.paginationDots = this.gallery.querySelectorAll('.slider-pagination__dot');
    this.currentSlideIndex = 0;

    if (this.paginationContainer) {
      this.init();
    }
  }

  init() {
    // Add click event listeners to pagination dots
    this.paginationDots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToSlide(index);
      });
    });

    // Listen for slide changes from existing slider functionality
    this.observeSlideChanges();
  }

  goToSlide(index) {
    if (index >= 0 && index < this.slides.length) {
      this.currentSlideIndex = index;
      
      // Update active slide
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      // Update active dot
      this.updateActiveDot(index);

      // Scroll to the slide (adjust based on your slider implementation)
      const slideWidth = this.slides[0].offsetWidth;
      this.slider.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });

      // Update slide counter if it exists
      this.updateSlideCounter(index + 1);

      // Trigger custom event for other components that might need to know about slide change
      this.gallery.dispatchEvent(new CustomEvent('slideChanged', {
        detail: { index: index, slide: this.slides[index] }
      }));
    }
  }

  updateActiveDot(activeIndex) {
    this.paginationDots.forEach((dot, index) => {
      dot.classList.toggle('slider-pagination__dot--active', index === activeIndex);
      dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
    });
  }

  updateSlideCounter(slideNumber) {
    const counterCurrent = this.gallery.querySelector('.slider-counter--current');
    if (counterCurrent) {
      counterCurrent.textContent = slideNumber;
    }
  }

  observeSlideChanges() {
    // Method 1: Observe scroll position changes
    let scrollTimeout;
    this.slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const slideWidth = this.slides[0].offsetWidth;
        const scrollLeft = this.slider.scrollLeft;
        const newIndex = Math.round(scrollLeft / slideWidth);
        
        if (newIndex !== this.currentSlideIndex) {
          this.currentSlideIndex = newIndex;
          this.updateActiveDot(newIndex);
          this.updateSlideCounter(newIndex + 1);
        }
      }, 100);
    });

    // Method 2: Listen for existing slider button clicks
    const prevButton = this.gallery.querySelector('.slider-button--prev');
    const nextButton = this.gallery.querySelector('.slider-button--next');

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        setTimeout(() => this.syncPaginationWithSlider(), 100);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        setTimeout(() => this.syncPaginationWithSlider(), 100);
      });
    }
  }

  syncPaginationWithSlider() {
    // Find the currently active slide
    const activeSlide = this.gallery.querySelector('.slider__slide.is-active');
    if (activeSlide) {
      const activeIndex = Array.from(this.slides).indexOf(activeSlide);
      if (activeIndex !== -1 && activeIndex !== this.currentSlideIndex) {
        this.currentSlideIndex = activeIndex;
        this.updateActiveDot(activeIndex);
      }
    }
  }
}

// Initialize pagination for all media galleries
document.addEventListener('DOMContentLoaded', () => {
  const mediaGalleries = document.querySelectorAll('media-gallery');
  mediaGalleries.forEach(gallery => {
    new MediaGalleryPagination(gallery);
  });
});

// If you're using Shopify's section loading, also initialize on section load
document.addEventListener('shopify:section:load', (event) => {
  const mediaGallery = event.target.querySelector('media-gallery');
  if (mediaGallery) {
    new MediaGalleryPagination(mediaGallery);
  }
});

